import { emptySplitApi } from "./empty-split-api";
import type {
  MentionCandidate,
  MentionCandidatesParams,
  MentionForMe,
  MentionsForMeParams,
  MentionsForMeResponse
} from "./types/mentions.type";

// Team @mentions (TEAM_MENTIONS_FEATURE): the people the @ pickers offer. Writer excluded,
// prefix match on each name, people at `clinic` first, at most 20.
export const mentionsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getMentionCandidates: builder.query<
      MentionCandidate[],
      MentionCandidatesParams
    >({
      query: (params) => ({
        url: `/mention-candidates/`,
        params
      }),
      // A picker that should reflect who is active right now; never served stale.
      keepUnusedDataFor: 0
    }),
    // Home → For me (TEAMS_FEATURE): my own mention rows, by name or through a team, newest first.
    getMentionsForMe: builder.query<MentionsForMeResponse, MentionsForMeParams>(
      {
        query: ({ limit = 50, offset = 0, ...params }) => ({
          url: `/mentions/for-me/`,
          params: { limit, offset, ...params }
        }),
        // `CustomLimitOffsetPagination` answers a flat array (no count envelope); wrap it.
        transformResponse: (
          response: MentionForMe[] | MentionsForMeResponse
        ): MentionsForMeResponse =>
          Array.isArray(response)
            ? {
                count: response.length,
                next: null,
                previous: null,
                results: response
              }
            : response,
        providesTags: ["MentionsForMe"]
      }
    )
  })
});

export const { useLazyGetMentionCandidatesQuery, useGetMentionsForMeQuery } =
  mentionsApi;
